import { MenuItem, ToggleButton, ToggleButtonGroup, Typography, useMediaQuery, useTheme } from '@mui/material';
import { PeriodicType } from 'app/shared/model/enumerations/periodicType';
import React from 'react';
import { Translate } from 'react-jhipster';
import { SelectDefault } from '../select-default/SelectDefault';

export const PeriodButtonsNew = (
  stateSelectedPeriodic,
  sendSensorDataByImplementIdAndPeriodic,
  changeToCustomPeriodic,
  isCompany: boolean,
  loading: boolean,
  onlyPastData?: boolean,
  showMonthlyPeriods?: boolean,
  forceSelect = false
) => {
  const theme = useTheme();
  const isXsScreen = useMediaQuery(theme.breakpoints.down('md'));
  const useSelect = forceSelect || isXsScreen;
  const periodNames = showMonthlyPeriods ? ['MONTH', 'QUARTERLY', 'SEMI_ANNUAL', 'CUSTOM'] : ['TODAY', 'YESTERDAY', 'WEEK', 'CUSTOM'];

  const changeFunction = period => {
    if (period === PeriodicType.CUSTOM) {
      return changeToCustomPeriodic();
    }
    return sendSensorDataByImplementIdAndPeriodic(period);
  };

  const filteredPeriodNames = (() => {
    const blockedPeriods: string[] = [];

    if (isCompany) blockedPeriods.push('TODAY', 'YESTERDAY');
    if (onlyPastData) blockedPeriods.push('TODAY');

    return periodNames.filter(item => !blockedPeriods.includes(item));
  })();

  return (
    <>
      {useSelect ? (
        <SelectDefault value={stateSelectedPeriodic} mobileFullWidth minWidth={125}>
          {filteredPeriodNames.map(period => (
            <MenuItem key={period} value={period} onClick={() => changeFunction(period)}>
              <Typography sx={{ fontSize: '.875rem' }}>
                <Translate contentKey={`fleetSenseApp.periodicType.${period?.toLowerCase()}`} />
              </Typography>
            </MenuItem>
          ))}
        </SelectDefault>
      ) : (
        <ToggleButtonGroup color="secondary" size="medium" value={stateSelectedPeriodic} exclusive>
          {filteredPeriodNames.map(period => (
            <ToggleButton key={period} value={period} onClick={() => changeFunction(period)}>
              <Typography sx={{ fontSize: '.875rem', lineHeight: '21px', whiteSpace: 'nowrap' }}>
                <Translate contentKey={`fleetSenseApp.periodicType.${period?.toLowerCase()}`} />
              </Typography>
            </ToggleButton>
          ))}
        </ToggleButtonGroup>
      )}
    </>
  );
};
